export default __webpack_public_path__ + "static/media/picture.1607802c.svg";